/** @format */

import React from "react";
import CountUp from "react-countup";
import Carousel1 from "../Component/Carousel1";
import TestimonialCarousel from "../Component/TestimonialCarousel";

function Home() {
  return (
    <>
      {/* Carousel Start */}
      <div
        className="container-fluid p-0 pb-5 wow fadeIn"
        data-wow-delay="0.1s"
      >
        <Carousel1 />
      </div>
      {/* Carousel End */}
      {/* Feature Start */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-5">
            <div className="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.1s">
              <div className="d-flex align-items-center mb-4">
                <div className="btn-lg-square bg-primary rounded-circle me-3">
                  <i className="fa fa-users text-white" />
                </div>
                <h1 className="mb-0" data-toggle="counter-up">
                  {" "}
                  <CountUp end={3453} enableScrollSpy />
                </h1>
              </div>
              <h5 className="mb-3">Happy Customers</h5>
              <span>
                "I was so impressed with the quality of your product and the
                level of customer service I received. I will definitely be
                recommending your business to my friends and family." - John
                Smith
              </span>
            </div>
            <div className="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.3s">
              <div className="d-flex align-items-center mb-4">
                <div className="btn-lg-square bg-primary rounded-circle me-3">
                  <i className="fa fa-check text-white" />
                </div>
                <h1 className="mb-0" data-toggle="counter-up">
                  <CountUp end={4234} enableScrollSpy />
                </h1>
              </div>
              <h5 className="mb-3">Project Done</h5>
              <span>
                1. The goals of the project and whether they were achieved.{" "}
                <br />
                2. The challenges that were faced and how they were overcome.{" "}
                <br />
                3. The impact of the project on the stakeholders and the
                community. <br />
                4. The lessons learned from the project.
              </span>
            </div>
            <div className="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.5s">
              <div className="d-flex align-items-center mb-4">
                <div className="btn-lg-square bg-primary rounded-circle me-3">
                  <i className="fa fa-award text-white" />
                </div>
                <h1 className="mb-0" data-toggle="counter-up">
                  {" "}
                  <CountUp end={3123} enableScrollSpy />
                </h1>
              </div>
              <h5 className="mb-3">Awards Win</h5>
              <span>
                1. The name of the award and the organization that presented it.{" "}
                <br />
                2. What the award is for. <br />
                3. Why your company or project was chosen for the award. <br />
                4. The impact of the award on your company or project.
              </span>
            </div>
            <div className="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.7s">
              <div className="d-flex align-items-center mb-4">
                <div className="btn-lg-square bg-primary rounded-circle me-3">
                  <i className="fa fa-users-cog text-white" />
                </div>
                <h1 className="mb-0" data-toggle="counter-up">
                  <CountUp end={1831} enableScrollSpy />
                </h1>
              </div>
              <h5 className="mb-3">Expert Workers</h5>
              <span>
                John Smith is a senior engineer at our company with over 20
                years of experience in the field of renewable energy. He has
                worked on a wide range of projects, from small-scale residential
                solar systems to large-scale commercial wind farms. John is an
                expert in all aspects of renewable energy, from design and
                engineering to installation and maintenance.
              </span>
            </div>
          </div>
        </div>
      </div>
      {/* Feature Start */}
      {/* About Start */}
      <div className="container-fluid bg-light overflow-hidden my-5 px-lg-0">
        <div className="container about px-lg-0">
          <div className="row g-0 mx-lg-0">
            <div
              className="col-lg-6 ps-lg-0 wow fadeIn"
              data-wow-delay="0.1s"
              style={{ minHeight: "400px" }}
            >
              <div className="position-relative h-100">
                <img
                  className="position-absolute img-fluid w-100 h-100"
                  src="img/about.jpg"
                  style={{ objectFit: "cover" }}
                  alt=""
                />
              </div>
            </div>
            <div
              className="col-lg-6 about-text py-5 wow fadeIn"
              data-wow-delay="0.5s"
            >
              <div className="p-lg-5 pe-lg-0">
                <h6 className="text-primary">About Us</h6>
                <h1 className="mb-4">
                  25+ Years Experience In Solar &amp; Renewable Energy Industry
                </h1>
                <p>
                  We are a leading provider of renewable energy solutions,
                  committed to providing our customers with the best possible
                  service and a sustainable future.
                </p>
                <p>
                  <i className="fa fa-check-circle text-primary me-3" />
                  We are a leading provider of renewable energy solutions.
                </p>
                <p>
                  <i className="fa fa-check-circle text-primary me-3" />
                  We are committed to providing our customers with the best
                  possible service.
                </p>
                <p>
                  <i className="fa fa-check-circle text-primary me-3" />
                  We are committed to a sustainable future.
                </p>
                <a href className="btn btn-primary rounded-pill py-3 px-5 mt-3">
                  Explore More
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* About End */}
      {/* Service Start */}
      <div className="container-xxl py-5">
        <div className="container">
          <div
            className="text-center mx-auto mb-5 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ maxWidth: "600px" }}
          >
            <h6 className="text-primary">Our Services</h6>
            <h1 className="mb-4">
              We Are Pioneers In The World Of Renewable Energy
            </h1>
          </div>
          <div className="row g-4">
            <div
              className="col-md-6 col-lg-4 wow fadeInUp"
              data-wow-delay="0.1s"
            >
              <div className="service-item rounded overflow-hidden">
                <img className="img-fluid" src="img/img-600x400-1.jpg" alt="" />
                <div className="position-relative p-4 pt-0">
                  <div className="service-icon">
                    <i className="fa fa-solar-panel fa-3x" />
                  </div>
                  <h4 className="mb-3">Solar Energy</h4>
                  <p>
                    Solar energy financing <br />
                    Solar energy monitoring <br />
                    Solar panel installation
                  </p>
                  <a className="small fw-medium" href>
                    Read More
                    <i className="fa fa-arrow-right ms-2" />
                  </a>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 col-lg-4 wow fadeInUp"
              data-wow-delay="0.3s"
            >
              <div className="service-item rounded overflow-hidden">
                <img
                  className="img-fluid"
                  src="img/wind4.jpeg"
                  alt=""
                  style={{ width: 400, height: 280 }}
                />
                <div className="position-relative p-4 pt-0">
                  <div className="service-icon">
                    <i className="fa fa-wind fa-3x" />
                  </div>
                  <h4 className="mb-3">Wind Energy</h4>
                  <p>
                    Wind Energy Consulting <br />
                    Wind Energy Financing
                  </p>
                  <a className="small fw-medium" href>
                    Read More
                    <i className="fa fa-arrow-right ms-2" />
                  </a>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 col-lg-4 wow fadeInUp"
              data-wow-delay="0.5s"
            >
              <div className="service-item rounded overflow-hidden">
                <img
                  className="img-fluid"
                  src="img/hydropower2.jpeg"
                  alt=""
                  style={{ width: 400, height: 280 }}
                />
                <div className="position-relative p-4 pt-0">
                  <div className="service-icon">
                    <i className="fa fa-lightbulb fa-3x" />
                  </div>
                  <h4 className="mb-3">Hydropower Plants</h4>
                  <p>
                    Electricity generation <br />
                    Irrigation
                    <br />
                    Recreation
                  </p>
                  <a className="small fw-medium" href>
                    Read More
                    <i className="fa fa-arrow-right ms-2" />
                  </a>
                </div>
              </div>
            </div>
            {/* <div
              className="col-md-6 col-lg-4 wow fadeInUp"
              data-wow-delay="0.1s"
            >
              <div className="service-item rounded overflow-hidden">
                <img className="img-fluid" src="img/img-600x400-4.jpg" alt="" />
                <div className="position-relative p-4 pt-0">
                  <div className="service-icon">
                    <i className="fa fa-solar-panel fa-3x" />
                  </div>
                  <h4 className="mb-3">Solar Panels</h4>
                  <p>
                  <b>Solar panel installation:</b> Solar panels can be
                    installed on rooftops, in yards, or on commercial buildings.
                    We as providers can help you choose the right solar panel
                    system for your needs and budget, and can handle the entire
                    installation process. <br />
                    <b>Solar panel maintenance:</b> Solar panels require very
                    little maintenance, but it is important to have them
                    inspected and cleaned regularly. We can offer solar panel
                    maintenance plans to ensure that your panels are operating
                    at peak efficiency.
                  </p>
                  <a className="small fw-medium" href>
                    Read More
                    <i className="fa fa-arrow-right ms-2" />
                  </a>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 col-lg-4 wow fadeInUp"
              data-wow-delay="0.3s"
            >
              <div className="service-item rounded overflow-hidden">
                <img className="img-fluid" src="img/wind3.jpeg"
                  alt=""
                  style={{ width: 400, height: 280 }}/>
                <div className="position-relative p-4 pt-0">
                  <div className="service-icon">
                    <i className="fa fa-wind fa-3x" />
                  </div>
                  <h4 className="mb-3">Wind Turbines</h4>
                  <p>
                  <b>Wind turbine installation:</b> Wind turbines can be
                    installed on land or offshore. Wind energy services
                    providers can help you choose the right wind turbine system
                    for your needs and budget, and they can handle the entire
                    installation process. <br />
                    <b>Wind turbine maintenance:</b> Wind turbines require
                    regular maintenance to ensure that they are operating safely
                    and efficiently. Wind energy services providers can offer
                    wind turbine maintenance plans to ensure that your turbines
                    are always in good condition.
                  </p>
                  <a className="small fw-medium" href>
                    Read More
                    <i className="fa fa-arrow-right ms-2" />
                  </a>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 col-lg-4 wow fadeInUp"
              data-wow-delay="0.5s"
            >
              <div className="service-item rounded overflow-hidden">
                <img className="img-fluid" src="img/img-600x400-6.jpg" alt="" />
                <div className="position-relative p-4 pt-0">
                  <div className="service-icon">
                    <i className="fa fa-lightbulb fa-3x" />
                  </div>
                  <h4 className="mb-3">Hydropower Plants</h4>
                  <p>
                    Stet stet justo dolor sed duo. Ut clita sea sit ipsum diam
                    lorem diam.
                  </p>
                  <a className="small fw-medium" href>
                    Read More
                    <i className="fa fa-arrow-right ms-2" />
                  </a>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      {/* Service End */}
      {/* Feature Start */}
      <div className="container-fluid bg-light overflow-hidden my-5 px-lg-0">
        <div className="container feature px-lg-0">
          <div className="row g-0 mx-lg-0">
            <div
              className="col-lg-6 feature-text py-5 wow fadeIn"
              data-wow-delay="0.1s"
            >
              <div className="p-lg-5 ps-lg-0">
                <h6 className="text-primary">Why Choose Us!</h6>
                <h1 className="mb-4">
                  Complete Commercial &amp; Residential Solar Systems
                </h1>
                <p className="mb-4 pb-2">
                  We are experts in renewable energy. We have a team of
                  experienced and certified professionals who are passionate
                  about renewable energy. We can help you choose the right
                  renewable energy system for your needs and budget, and we can
                  install and maintain your system to the highest standards.{" "}
                  <br />
                  We offer a wide range of renewable energy solutions. We can
                  provide you with solar panels, wind turbines, hydropower
                  systems, and biomass systems. We also offer energy storage
                  solutions to help you save money on your energy bills and to
                  reduce your reliance on the grid. <br />
                  We are committed to providing our customers with the best
                  possible service. We work closely with our customers to
                  understand their needs and to develop a renewable energy
                  solution that is right for them. We also offer comprehensive
                  warranties on all of our products and services.
                </p>
                <div className="row g-4">
                  <div className="col-6">
                    <div className="d-flex align-items-center">
                      <div className="btn-lg-square bg-primary rounded-circle">
                        <i className="fa fa-check text-white" />
                      </div>
                      <div className="ms-4">
                        <p className="mb-0">Quality</p>
                        <h5 className="mb-0">Services</h5>
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="d-flex align-items-center">
                      <div className="btn-lg-square bg-primary rounded-circle">
                        <i className="fa fa-user-check text-white" />
                      </div>
                      <div className="ms-4">
                        <p className="mb-0">Expert</p>
                        <h5 className="mb-0">Workers</h5>
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="d-flex align-items-center">
                      <div className="btn-lg-square bg-primary rounded-circle">
                        <i className="fa fa-drafting-compass text-white" />
                      </div>
                      <div className="ms-4">
                        <p className="mb-0">Free</p>
                        <h5 className="mb-0">Consultation</h5>
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="d-flex align-items-center">
                      <div className="btn-lg-square bg-primary rounded-circle">
                        <i className="fa fa-headphones text-white" />
                      </div>
                      <div className="ms-4">
                        <p className="mb-0">Customer</p>
                        <h5 className="mb-0">Support</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-lg-6 pe-lg-0 wow fadeIn"
              data-wow-delay="0.5s"
              style={{ minHeight: "400px" }}
            >
              <div className="position-relative h-100">
                <img
                  className="position-absolute img-fluid w-100 h-100"
                  src="img/feature.jpg"
                  style={{ objectFit: "cover" }}
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Feature End */}
      {/* Projects Start */}
      <div className="container-xxl py-5">
        <div className="container">
          <div
            className="text-center mx-auto mb-5 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ maxWidth: "600px" }}
          >
            <h6 className="text-primary">Our Projects</h6>
            <h1 className="mb-4">
              Visit Our Latest Solar And Renewable Energy Projects
            </h1>
          </div>
          <div className="row mt-n2 wow fadeInUp" data-wow-delay="0.3s">
            <div className="col-12 text-center">
              <ul className="list-inline mb-5" id="portfolio-flters">
                <li className="mx-2 active" data-filter="*">
                  All
                </li>
                <li className="mx-2" data-filter=".first">
                  Solar Panels
                </li>
                <li className="mx-2" data-filter=".second">
                  Wind Turbines
                </li>
                <li className="mx-2" data-filter=".third">
                  Hydropower Plants
                </li>
              </ul>
            </div>
          </div>
          <div
            className="row g-4 portfolio-container wow fadeInUp"
            data-wow-delay="0.5s"
          >
            <div className="col-lg-4 col-md-6 portfolio-item first">
              <div className="portfolio-img rounded overflow-hidden">
                <img className="img-fluid" src="img/img-600x400-6.jpg" alt="" />
                <div className="portfolio-btn">
                  <a
                    className="btn btn-lg-square btn-outline-light rounded-circle mx-1"
                    href="img/img-600x400-6.jpg"
                    data-lightbox="portfolio"
                  >
                    <i className="fa fa-eye" />
                  </a>
                  <a
                    className="btn btn-lg-square btn-outline-light rounded-circle mx-1"
                    href
                  >
                    <i className="fa fa-link" />
                  </a>
                </div>
              </div>
              <div className="pt-3">
                <p className="text-primary mb-0">Solar Panels</p>
                <hr className="text-primary w-25 my-2" />
                <h5 className="lh-base">
                  We Are pioneers of solar &amp; renewable energy industry.{" "}
                  <br />
                  Projects: <br />
                  Floating Solar PV Plant <br />
                  Solar-Powered Village <br />
                  Solar-Powered Desalination Plant
                </h5>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 portfolio-item second">
              <div className="portfolio-img rounded overflow-hidden">
                <img className="img-fluid" src="img/img-600x400-5.jpg" alt="" />
                <div className="portfolio-btn">
                  <a
                    className="btn btn-lg-square btn-outline-light rounded-circle mx-1"
                    href="img/img-600x400-5.jpg"
                    data-lightbox="portfolio"
                  >
                    <i className="fa fa-eye" />
                  </a>
                  <a
                    className="btn btn-lg-square btn-outline-light rounded-circle mx-1"
                    href
                  >
                    <i className="fa fa-link" />
                  </a>
                </div>
              </div>
              <div className="pt-3">
                <p className="text-primary mb-0">Wind Turbines</p>
                <hr className="text-primary w-25 my-2" />
                <h5 className="lh-base">
                  We Are pioneers of solar &amp; renewable energy industry{" "}
                  <br /> Offshore Wind Farms <br /> Community wind farms
                </h5>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 portfolio-item third">
              <div className="portfolio-img rounded overflow-hidden">
                <img className="img-fluid" src="img/img-600x400-4.jpg" alt="" />
                <div className="portfolio-btn">
                  <a
                    className="btn btn-lg-square btn-outline-light rounded-circle mx-1"
                    href="img/img-600x400-4.jpg"
                    data-lightbox="portfolio"
                  >
                    <i className="fa fa-eye" />
                  </a>
                  <a
                    className="btn btn-lg-square btn-outline-light rounded-circle mx-1"
                    href
                  >
                    <i className="fa fa-link" />
                  </a>
                </div>
              </div>
              <div className="pt-3">
                <p className="text-primary mb-0">Hydropower Plants</p>
                <hr className="text-primary w-25 my-2" />
                <h5 className="lh-base">
                  We Are pioneers of solar &amp; renewable energy industry{" "}
                  <br />
                  Run-of-river hydropower plants
                </h5>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 portfolio-item first">
              <div className="portfolio-img rounded overflow-hidden">
                <img className="img-fluid" src="img/img-600x400-3.jpg" alt="" />
                <div className="portfolio-btn">
                  <a
                    className="btn btn-lg-square btn-outline-light rounded-circle mx-1"
                    href="img/img-600x400-3.jpg"
                    data-lightbox="portfolio"
                  >
                    <i className="fa fa-eye" />
                  </a>
                  <a
                    className="btn btn-lg-square btn-outline-light rounded-circle mx-1"
                    href
                  >
                    <i className="fa fa-link" />
                  </a>
                </div>
              </div>
              <div className="pt-3">
                <p className="text-primary mb-0">Solar Panels</p>
                <hr className="text-primary w-25 my-2" />
                <h5 className="lh-base">
                  We Are pioneers of solar &amp; renewable energy industry
                </h5>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 portfolio-item second">
              <div className="portfolio-img rounded overflow-hidden">
                <img className="img-fluid" src="img/img-600x400-2.jpg" alt="" />
                <div className="portfolio-btn">
                  <a
                    className="btn btn-lg-square btn-outline-light rounded-circle mx-1"
                    href="img/img-600x400-2.jpg"
                    data-lightbox="portfolio"
                  >
                    <i className="fa fa-eye" />
                  </a>
                  <a
                    className="btn btn-lg-square btn-outline-light rounded-circle mx-1"
                    href
                  >
                    <i className="fa fa-link" />
                  </a>
                </div>
              </div>
              <div className="pt-3">
                <p className="text-primary mb-0">Wind Turbines</p>
                <hr className="text-primary w-25 my-2" />
                <h5 className="lh-base">
                  We Are pioneers of solar &amp; renewable energy industry
                </h5>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 portfolio-item third">
              <div className="portfolio-img rounded overflow-hidden">
                <img className="img-fluid" src="img/img-600x400-1.jpg" alt="" />
                <div className="portfolio-btn">
                  <a
                    className="btn btn-lg-square btn-outline-light rounded-circle mx-1"
                    href="img/img-600x400-1.jpg"
                    data-lightbox="portfolio"
                  >
                    <i className="fa fa-eye" />
                  </a>
                  <a
                    className="btn btn-lg-square btn-outline-light rounded-circle mx-1"
                    href
                  >
                    <i className="fa fa-link" />
                  </a>
                </div>
              </div>
              <div className="pt-3">
                <p className="text-primary mb-0">Hydropower Plants</p>
                <hr className="text-primary w-25 my-2" />
                <h5 className="lh-base">
                  We Are pioneers of solar &amp; renewable energy industry
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Projects End */}
      {/* Quote Start */}
      <div className="container-fluid bg-light overflow-hidden my-5 px-lg-0">
        <div className="container quote px-lg-0">
          <div className="row g-0 mx-lg-0">
            <div
              className="col-lg-6 ps-lg-0 wow fadeIn"
              data-wow-delay="0.1s"
              style={{ minHeight: "400px" }}
            >
              <div className="position-relative h-100">
                <img
                  className="position-absolute img-fluid w-100 h-100"
                  src="img/quote.jpg"
                  style={{ objectFit: "cover" }}
                  alt=""
                />
              </div>
            </div>
            <div
              className="col-lg-6 quote-text py-5 wow fadeIn"
              data-wow-delay="0.5s"
            >
              <div className="p-lg-5 pe-lg-0">
                <h6 className="text-primary">Free Quote</h6>
                <h1 className="mb-4">Get A Free Quote</h1>
                <p className="mb-4 pb-2">
                  “To truly transform our economy, protect our security, and
                  save our planet from the ravages of climate change, we need to
                  ultimately make clean, renewable energy the profitable kind of
                  energy.” —Barack Obama <br />
                  <b>Feel free to share your quotes with us.</b>
                </p>
                <form>
                  <div className="row g-3">
                    <div className="col-12 col-sm-6">
                      <input
                        type="text"
                        className="form-control border-0"
                        placeholder="Your Name"
                        style={{ height: "55px" }}
                      />
                    </div>
                    <div className="col-12 col-sm-6">
                      <input
                        type="email"
                        className="form-control border-0"
                        placeholder="Your Email"
                        style={{ height: "55px" }}
                      />
                    </div>
                    <div className="col-12 col-sm-6">
                      <input
                        type="text"
                        className="form-control border-0"
                        placeholder="Your Mobile"
                        style={{ height: "55px" }}
                      />
                    </div>
                    <div className="col-12 col-sm-6">
                      <select
                        className="form-select border-0"
                        style={{ height: "55px" }}
                      >
                        <option selected>Select A Service</option>
                        <option value={1}>Service 1</option>
                        <option value={2}>Service 2</option>
                        <option value={3}>Service 3</option>
                      </select>
                    </div>
                    <div className="col-12">
                      <textarea
                        className="form-control border-0"
                        placeholder="Special Note"
                        defaultValue={""}
                      />
                    </div>
                    <div className="col-12">
                      <button
                        className="btn btn-primary rounded-pill py-3 px-5"
                        type="submit"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Quote End */}
      {/* Team Start */}
      <div className="container-xxl py-5">
        <div className="container">
          <div
            className="text-center mx-auto mb-5 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ maxWidth: "600px" }}
          >
            <h6 className="text-primary">Team Member</h6>
            <h1 className="mb-4">Experienced Team Members</h1>
          </div>
          <div className="row g-4">
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="0.1s"
            >
              <div className="team-item rounded overflow-hidden">
                <div className="d-flex">
                  <img className="img-fluid w-75" src="img/team-1.jpg" alt="" />
                  <div className="team-social w-25">
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-twitter" />
                    </a>
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-instagram" />
                    </a>
                  </div>
                </div>
                <div className="p-4">
                  <h5>Rohan</h5>
                  <span>Designation - Field Engineer</span>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="0.3s"
            >
              <div className="team-item rounded overflow-hidden">
                <div className="d-flex">
                  <img className="img-fluid w-75" src="img/team-2.jpg" alt="" />
                  <div className="team-social w-25">
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-twitter" />
                    </a>
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-instagram" />
                    </a>
                  </div>
                </div>
                <div className="p-4">
                  <h5>Jack</h5>
                  <span>Designation - Civil Engineer</span>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="0.5s"
            >
              <div className="team-item rounded overflow-hidden">
                <div className="d-flex">
                  <img className="img-fluid w-75" src="img/team-3.jpg" alt="" />
                  <div className="team-social w-25">
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-twitter" />
                    </a>
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-instagram" />
                    </a>
                  </div>
                </div>
                <div className="p-4">
                  <h5>Raj</h5>
                  <span>Designation - Electrical Designer</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Team End */}
      {/* Testimonial Start */}
      <div className="container-xxl py-5">
        <div className="container">
          <div
            className="text-center mx-auto mb-5 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ maxWidth: "600px" }}
          >
            <h6 className="text-primary">Testimonial</h6>
            <h1 className="mb-4">What Our Clients Say!</h1>
          </div>
          <TestimonialCarousel />
          {/* <div className="owl-carousel testimonial-carousel wow fadeInUp" data-wow-delay="0.1s">
                        <div className="testimonial-item text-center">
                            <div className="testimonial-img position-relative">
                                <img className="img-fluid rounded-circle mx-auto mb-5" src="img/testimonial-1.jpg" />
                                <div className="btn-square bg-primary rounded-circle">
                                    <i className="fa fa-quote-left text-white" />
                                </div>
                            </div>
                            <div className="testimonial-text text-center rounded p-4">
                                <p>Clita clita tempor justo dolor ipsum amet kasd amet duo justo duo duo labore sed sed. Magna ut diam sit et amet stet eos sed clita erat magna elitr erat sit sit erat at rebum justo sea clita.</p>
                                <h5 className="mb-1">Client Name</h5>
                                <span className="fst-italic">Profession</span>
                            </div>
                        </div>
                        <div className="testimonial-item text-center">
                            <div className="testimonial-img position-relative">
                                <img className="img-fluid rounded-circle mx-auto mb-5" src="img/testimonial-2.jpg" />
                                <div className="btn-square bg-primary rounded-circle">
                                    <i className="fa fa-quote-left text-white" />
                                </div>
                            </div>
                            <div className="testimonial-text text-center rounded p-4">
                                <p>Clita clita tempor justo dolor ipsum amet kasd amet duo justo duo duo labore sed sed. Magna ut diam sit et amet stet eos sed clita erat magna elitr erat sit sit erat at rebum justo sea clita.</p>
                                <h5 className="mb-1">Client Name</h5>
                                <span className="fst-italic">Profession</span>
                            </div>
                        </div>
                        <div className="testimonial-item text-center">
                            <div className="testimonial-img position-relative">
                                <img className="img-fluid rounded-circle mx-auto mb-5" src="img/testimonial-3.jpg" />
                                <div className="btn-square bg-primary rounded-circle">
                                    <i className="fa fa-quote-left text-white" />
                                </div>
                            </div>
                            <div className="testimonial-text text-center rounded p-4">
                                <p>Clita clita tempor justo dolor ipsum amet kasd amet duo justo duo duo labore sed sed. Magna ut diam sit et amet stet eos sed clita erat magna elitr erat sit sit erat at rebum justo sea clita.</p>
                                <h5 className="mb-1">Client Name</h5>
                                <span className="fst-italic">Profession</span>
                            </div>
                        </div>
                    </div> */}
        </div>
      </div>
      {/* Testimonial End */}
    </>
  );
}

export default Home;
